import Api from './../service/Api';

export default {
  facesCompare: (renach, cpf, image, codCfc) => Api.post('biometriaPR', {
    renach: renach,
    cpf: cpf,
    base64: image,
    codCfc: codCfc,
  }),
};
